<template>
  <cupshe-table
    rowKey="id"
    :columns="columns"
    :data-source="transformedMenuList"
    is-drag
    @dragChange="dragChange"
  >
    <template #deal="{text}">
      <a-button
        type="link"
        v-if="text.menuType == 1"
        @click="() => show(0, text)"
        >创建子菜单</a-button
      >
      <create-button
        v-if="text.menuType == 2"
        :text="text"
        title="创建按钮"
      ></create-button>
      <a-button type="link" @click="() => deleteInfo(text.id)">删除</a-button>
      <!-- 修改 -->
      <create-button
        v-if="text.menuType == 3"
        :text="text"
        title="修改"
      ></create-button>
      <a-button v-else type="link" @click="() => show(1, text)">修改</a-button>
    </template>
  </cupshe-table>
  <Pagination v-if="dataList && dataList.length > 0" />
  <!-- type 创建类型 1 菜单 2 子菜单  3 按钮  -->
  <EventAlert v-if="visible" :type="type" />
</template>
<script>
import { toRefs, inject, computed } from 'vue'
import EventAlert from './EventAlert'
import CreateButton from './CreateButton'
import { message } from 'ant-design-vue'
import { menu_sort_post } from 'server/modules/351.js'
export default {
  components: {
    EventAlert,
    CreateButton
  },
  setup() {
    const state = inject('state')
    const menusState = inject('menusState')

    const dragChange = async data => {
      const result = await menu_sort_post({
        sourceId: data.source.id,
        targetId: data.target.id
      })
      if (result.success) {
        menusState.queryMenuList()
      } else {
        message.warn(result.retInfo)
      }
    }
    const deleteInfo = id => {
      state.deleteItem(id, () => {
        menusState.queryMenuList()
      })
    }

    // 转换数据结构，将 childrenList 转换为 children
    const transformedMenuList = computed(() => {
      const transformData = data => {
        return data.map(item => {
          const newItem = { ...item }
          if (item.childrenList && item.childrenList.length > 0) {
            newItem.children = transformData(item.childrenList)
            delete newItem.childrenList
          }
          return newItem
        })
      }
      return menusState.menuList ? transformData(menusState.menuList) : []
    })

    return {
      deleteInfo,
      dragChange,
      transformedMenuList,
      ...toRefs(menusState),
      columns: [
        {
          title: '页面名称',
          dataIndex: 'menuName',
          key: 'menuName',
          width: '25%'
        },
        {
          title: '页面路径',
          dataIndex: 'menuPath',
          key: 'menuPath'
        },
        {
          title: '按钮Code',
          dataIndex: 'menuCode',
          key: 'menuCode',
          width: '25%'
        },
        {
          title: '操作',
          key: 'deal',
          width: 300,
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped></style>
